<template>
  <div @click.stop="membershipOnly && $store.dispatch('moveLimitedPage', path)">
    <a
      v-if="url"
      :href="url"
      class="magazineCard"
      :class="{ wide, articleIndex }"
      target="_blank"
      rel="noopener noreferrer"
    >
      <component
        :is="cardComponent"
        :wide="wide"
        :image="image"
        :imageAlt="imageAlt"
        :title="title"
        :date="date"
        :category="category"
        :description="description"
        :showPr="showPr"
      />
    </a>
    <router-link
      v-else
      :to="path"
      class="magazineCard"
      :class="{ wide, articleIndex }"
    >
      <component
        :is="cardComponent"
        :wide="wide"
        :image="image"
        :imageAlt="imageAlt"
        :title="title"
        :date="date"
        :category="category"
        :description="description"
        :showPr="showPr"
      />
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import MagazineCardContent from '@/components/block/MagazineCardContent.vue'
import MagazineCardSeriesContent from '@/components/block/MagazineCardSeriesContent.vue'
export default defineComponent({
  name: 'MagazineCard',
  components: {
    MagazineCardContent,
    MagazineCardSeriesContent
  },
  props: {
    image: String,
    imageAlt: String,
    title: String,
    description: String,
    path: String,
    category: String,
    wide: Boolean,
    date: String,
    membershipOnly: Boolean,
    url: String,
    parentCategorySlug: String,
    articleIndex: {
      type: Boolean,
      default: false
    },
    showPr: Boolean
  },
  setup(props) {
    const headingClass = {
      magazineCard_heading: !props.wide,
      magazineCard_heading_wide: props.wide
    }
    // 「連載」記事一覧ページなどでレイアウト変更
    const cardComponent = computed(() =>
      props.articleIndex ? 'MagazineCardSeriesContent' : 'MagazineCardContent'
    )

    return {
      headingClass,
      cardComponent
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
.wide {
  display: grid;
  grid-template-columns: 120px 1fr;
  width: 100%;
  &.articleIndex {
    display: block;
    overflow: hidden;
    @include mixins.media() {
      display: grid;
      grid-template-columns: 180px 1fr;
    }
  }
}
</style>
